<template>
    <div class="home">
        <div class="dialog-top" style="height:50px">
            <div class="left" style="width: 88px;">
                <span style="color:#cd1231;margin-left: -10px;">*</span>
                <span>活动地点</span>
            </div>
            <div class="right">
                <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                    <el-form-item class="item" prop="foodStreet">
                        <el-input   style="width: 270px;" v-model="searchForm.foodStreet" placeholder="请输入活动地点" size="small"  clearable>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="dialog-top" style="height:50px">
            <div class="left" style="width: 88px;">
                <span style="color:#cd1231;margin-left: -10px;">*</span>
                <span>城市</span>
            </div>
            <div class="right">
                <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                    <el-form-item class="item" prop="areaCode">
                        <el-select v-model="searchForm.areaCode" placeholder="请选择城市" size="small" style="width: 270px;" @change="changeArea(searchForm.areaCode)" clearable>
                            <el-option v-for="(item) in areaCodearr" :key="item.orgCode" :label="item.orgName.split('|')[0]" :value="item.orgCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="dialog-top" style="height:50px" v-if="!searchList.reviseObj">
            <div class="left" style="width: 88px;">
                <span style="color:#cd1231;margin-left: -10px;">*</span>
                <span>活动日期</span>
            </div>
            <div class="right">
                <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                    <el-form-item  v-if="!searchList.reviseObj" class="item" prop="timeList">
                        <el-input style="width:270px;" @click.native="showDatePicker()" readonly v-model="searchForm.timeListStr" placeholder="选择一个或多个日期" size="small" clearable>
                        </el-input>
                        <DatePicker
                            ref="datePickerRef"
                            align="right"
                            style="width:0px;overflow: hidden;"
                            :readonly="false"
                            :theme-start-time="searchList.themeBasic.themeStartTime"
                            :theme-end-time="searchList.themeBasic.themeEndTime"
                            @handleChangeDate="handleChangeDate"
                            /> 
                        <!-- <el-date-picker
                        @change="timeChange(searchForm.timeList)"
                        type="dates"
                        value-format="yyyy-MM-dd"
                        v-model="searchForm.timeList"
                        :picker-options="pickerOptions(searchList.themeBasic)"
                        placeholder="选择一个或多个日期"
                        size="small"
                        clearable
                        :default-value="defauleTime"
                        >
                        </el-date-picker> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="dialog-top" >
                <div class="left"  style="width: 88px;">
                    <span style="color:#cd1231;margin-left: -10px;">*</span>
                    <span>地址</span>
                </div>
                <div class="right">
                    <el-form  :model="searchForm" ref="searchForm" class="searchForm">

                        <el-form-item  prop="saleName" class="item" >
                            <el-cascader
                            style="width: 270px;"
                            size="small"
                            placeholder="请选择区县"
                            clearable
                            v-model="searchForm.area"
                            :options="areaOptions"
                            :props="{ expandTrigger: 'hover' }"
                            @change="handleChange"></el-cascader>
                        </el-form-item>
  
                        <el-form-item class="item"  prop="saleName">
                            <el-input style="width:270px" v-model="searchForm.address" placeholder="输入详细地址" size="small" clearable>
                            </el-input>
                        </el-form-item>
                        <!-- <el-form-item class="item">
                            <el-button type="primary" size="small" @click="clickSure()">确定</el-button>
                            <el-button type="info" size="small" @click="clickReset()">重置</el-button>
                        </el-form-item> -->
                    </el-form>
                </div>
        </div>
        <div class="dialog-top" style="height:50px" v-if="searchList.router">
            <div class="left" style="width: 88px;">
                <span>百威联系人</span>
            </div>
            <div class="right">
                <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                    <el-form-item class="item" prop="bwContactPerson">
                        <el-input style="width: 270px;" v-model="searchForm.bwContactPerson" placeholder="请输入百威联系人" size="small"  clearable>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="dialog-btn">
            <div class="btn-left" @click="closeDialog" >取消</div>
            <div class="btn-right" @click= 'clickOk'>确定</div>
        </div>
        <div class="dialog-close" @click="closeDialog()">
            <i class="el-icon-close" style="font-size: 28px;"></i>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import {regionData,CodeToText,TextToCode} from 'element-china-area-data'
    import gameplanApi from '../../../api/gameplan';
    import DatePicker from "../components/date-picker";
    export default {
      name: 'activity-report-empty-point',
      props: {
        options:{type:Object,default:()=>{}},
        searchList:{type:Object,default:()=>{}},
      },
      components: {
        DatePicker
      },
      data () {
        return {
            tableData: [],
            searchForm: {
                foodStreet:'',// 食街
                address:'',
                area:[], //省市区
                areaCode:'',
                bwContactPerson:'',
                areaName:'',
                timeList:[],
                timeListStr:'',
            },
            themeDetailId: '', 
            multipleSelection:[],
            selectOptions:[],
            pocRelateType: '',
            areaOptions:regionData,
            addtions:{},
            pocAddress:'',
            allArea:'',
            areaCodearr:[],
            defauleTime:'',
            pickerOptions(row = {}) {
                return{
                    disabledDate (time) {
                        return time.getTime() > row.themeEndTime ||  time.getTime() < row.themeStartTime 
                    }
                }
            },
            pickerOptionschange(row = {}) {
                return{
                    disabledDate (time) {
                        return time.getTime() < Date.now() - 8.64e7 ||  time.getTime() > row.themeEndTime ||  time.getTime() < row.themeStartTime 
                    }
                }
            },
        }
      },
      computed: {
        ...mapGetters(['userInfo']),   
      },
      watch: {},
      created () {
        this.pocRelateType = this.searchList.pocRelateType
        this.themeDetailId = this.searchList.themeDetailId
        // this.defauleTime = new Date(this.searchList.themeBasic.themeStartTime);
        // this.defauleTime.setMonth(new Date(this.searchList.themeBasic.themeStartTime).getMonth());
        this.init()
        console.log(this.searchList,'售点----searchList');
        if (this.searchList.reviseObj) {
            this.searchForm.foodStreet =  this.searchList.reviseObj[0].blockName
            let  blockAddress =   this.searchList.reviseObj[0].blockAddress.split('/')
            // let  blockAddress =   "北京市/市辖区/西城区/999999".split('/')
            // console.log(blockAddress);
            let arr1 = TextToCode[blockAddress[0]].code;
            let arr2 = TextToCode[blockAddress[0]][blockAddress[1]].code;
            let arr3 = TextToCode[blockAddress[0]][blockAddress[1]][blockAddress[2]].code;
            this.searchForm.area.push(arr1,arr2,arr3)
            if ( this.searchForm.area.length > 0) {
                this.handleChange(this.searchForm.area)
            }
            this.searchForm.address =  blockAddress[3]
            this.searchForm.areaCode = this.searchList.reviseObj[0].areaCode
            this.searchForm.bwContactPerson = this.searchList.reviseObj[0].bwContactPerson
            this.searchForm.areaName = this.searchList.reviseObj[0].areaName
            this.searchForm.timeList = this.searchList.reviseObj[0].timeList
            this.searchForm.timeListStr = this.searchList.reviseObj[0].timeList.join(',')
        }

      },
      mounted () {},
      updated () {},
      methods: {
        init () {
            this.getQueryarea()
        },
        timeChange (timeItem){
            // console.log(timeItem,'timeItem');
        },
        closeDialog () {
            this.$emit('closeMask')
        },
        showDatePicker(){
            const timeList = this.searchForm.timeList.map(item=>{
            const date = new Date(item.replace(/-/g, '/'))
              return date.getTime()
            })
            this.$refs.datePickerRef.showDatePicker(timeList)
        },
        handleChangeDate(dateList){
          this.searchForm.timeList = dateList
          this.searchForm.timeListStr = dateList.join(',')
          this.$refs.datePickerRef.hideDatePicker()
        }, 
        async getQueryarea () {
            let params = {
                'regionCode':this.searchList.regionCode
            }
           let res = await gameplanApi.getQueryarea(params)
           if (res.data.resultCode == '0') {
            this.areaCodearr = res.data.resultData.regionList            
           }
        },
        clickOk () {
            if (this.searchForm.foodStreet == '' || this.searchForm.address == '' || this.searchForm.area == '' || this.searchForm.areaCode == '' || this.searchForm.timeList == null || this.searchForm.timeList.length == 0) {
                this.$message.warning('信息添加不全，不能进行确认操作')
                return
            }
            if (this.searchList.needTransitions == 0 && !this.searchList.reviseObj) {
                if (this.searchList.perExecDays) {
                    if (this.searchForm.timeList.length  !== this.searchList.perExecDays) {
                    this.$message.error(`选择日期天数应与执行天数相等,当前已选 ${this.searchForm.timeList.length}天，应选 ${this.searchList.perExecDays}天`)
                    return
                }
                } else {
                    // this.$message.warning('配置天数未返回')
                    // return
                }

            }
            this.pocAddress =  this.allArea + this.searchForm.address
            let timeStamp = new Date().getTime()
            let arr = [{
                'block_name':this.searchForm.foodStreet,
                'pocAddress': this.pocAddress,
                'areaCode':this.searchForm.areaCode,
                'bwContactPerson':this.searchForm.bwContactPerson,
                'areaName':this.searchForm.areaName,
                'buName':this.searchList.buName,
                'regionName':this.searchList.regionName,
                'timeList':this.searchForm.timeList,
                'regionCode':this.searchList.regionCode,
                // 'buCode':this.searchList.buCode
                'timeStamp':timeStamp
            }]
            let number = this.addNumber(arr)
            // console.log(number,'number-当前',this.searchList.noAddnumber,'.noAddnumber-剩余')
            if (number > this.searchList.noAddnumber && !this.searchList.reviseObj) {
                // this.$message.warning(`添加场次超出未提报场次,已选择${number}场，剩余${this.searchList.noAddnumber}场`)
                this.$message.warning('添加场次超出未提报场次')
                return
            }
            if (!this.searchList.activityReturn) {
                if (this.searchList.reviseObj) {
                    this.$emit('deleteRow',this.searchList.reviseObj[0])
                }
                this.$emit('handleEmptyChange',arr)
            } else {
                this.$emit('handleEmptyChangereturn',arr)
            }
            this.$emit('closeMask')
        },
        clickSure () {
            this.pocAddress =  this.allArea + this.searchForm.address
            if (this.searchForm.foodStreet == '' || this.searchForm.address == '' || this.searchForm.area == '') {
                this.$message.warning('您未添加街区名称或地址，不能进行确认操作')
                return
            }
            let array = JSON.parse(JSON.stringify(this.tableData))
            if (array.length > 0) {
                for (let i = 0; i < array.length; i++) {
                    if (array[i].pocAddress == this.pocAddress ) {
                        this.$message.warning('您已经添加此项地址')
                        return
                    }    
                } 
            }
            this.tableData.push({
                'block_name':this.searchForm.foodStreet,
                'pocAddress': this.pocAddress
        })
        },
        clickReset () {
            this.searchForm.address = ''
            this.searchForm.area = ''
            this.searchForm.foodStreet = ''
        },
        deleteRow (row) {
            for (let i = 0; i < this.tableData.length; i++) {
                if ( this.tableData[i].pocAddress == row.pocAddress) {
                    this.tableData.splice(i,1)
                }
            }
        },
        handleChange (value) {
            let name = ''
            this.searchForm.area.map(item => name += CodeToText[item] + '/')
            this.allArea =  name
        },
        changeArea (val) {
            if (val) {
                for (let item of this.areaCodearr) {
                    if (item.orgCode == val) {
                        this.searchForm.areaName = item.orgName.split('|')[0]
                    }                 
                }              
            }
        },
        // 已添加
        addNumber (arr) {
            let allNum = 0
            if (this.searchList.needTransitions == 0) {
                allNum = arr.length
                // console.log(allNum,'allNum--0000');
                return allNum
            }
            else if (this.searchList.needTransitions == 1) {
                for (let item of arr) {
                    allNum = allNum + item.timeList.length
                }
                // console.log(allNum,'allNum--1111');
                return allNum
            }

        }
    }
}
</script>
<style lang="scss" scoped>
    .home {
        position: relative;
        .dialog-top {
            display: flex;
            // height: 100px;
            color: #101010;
            .left {
                width: 140px;
                line-height: 25px;
                font-size: 16px;
                text-align: left;
                font-weight: bold;
                margin-top: 5px;
            }
            .right {
                .searchForm {
                    width: 100%;
                    .item {
                        // width: 140px;
                        width: 170px;
                        line-height: 50px;
                        margin: 0 10px;
                    }
                }
            }
        }
        .dialog-form {
            margin-bottom: 20px;
            overflow: hidden;
            overflow-y:scroll;
            max-height: 400px;
            .delete-row {
                height: 20px;
                line-height: 20px;
                color: #409EFF;
                cursor: pointer;
            }
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);                               
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }
        }
        .dialog-bottom {
            position: relative;
            top: 0px;
            text-align: right;
        }
        .dialog-selected {
            overflow: hidden;
            overflow-y:scroll;
            max-height: 80px;
            .selected-tag {
                margin-top: 5px;
                ::v-deep.el-tag {
                    margin-right: 5px;
                    // color: #cd1231;
                    // background-color:rgb(249, 224, 228);
                }
            }
        }
        .dialog-btn {
            height: 30px;
            line-height: 30px;
            display: flex;
            justify-content:flex-end;
            .btn-left {
                width: 80px;
                text-align: center;
                background-color: #FFFFFF;
                color: #cd1231;
                border-radius: 5px;
                border: 1px solid #cd1231;
                margin-right: 10px;
                cursor: pointer;
            }
            .btn-right {
                width: 80px;
                text-align: center;
                background-color: #cd1231;
                color: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #cd1231;
                cursor: pointer;
            }
        }
        .dialog-close {
            width: 30px;
            height: 30px;
            position: absolute;
            top: -10px;
            right: -10px;
            cursor: pointer;
        }
    }

</style>